module.exports = __webpack_public_path__ + "img/play-button-desktop.a6f779339d9b118f9e75fdca4e359ad5.svg";